import { fs } from '../../Firebase'

export const subscribe = ({id, number}) => dispatch => {
    return fs.subscribe(id, number)
}


// WEBPACK FOOTER //
// ./src/Pages/Subscribe/actions.js